import { LoaderService } from './../loder_service/loader.service';
import { Storage } from '@ionic/storage';
import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent implements OnInit {
  notification:any;
  noti_count:any=0;
  constructor(public toastService:LoaderService, public restApi:DataService, public storage:Storage) { }

  ngOnInit() {}
ionViewWillEnter(){
 this.storage.get('user_id').then((user_id)=>{
  // alert(user_id)
   let postparams={
    usersessionId:user_id
   }
   this.restApi.get_notification(postparams).subscribe((data:any)=>{
    this.notification=data;
   this.noti_count= this.notification.length;
   //alert(this.noti_count)
   this.storage.set('noti_count',this.noti_count)
   this.toastService.hideLoader();
  },(error:any)=>{
   this.toastService.hideLoader();
  })
 })//storage
}
is_view_notification(item){
  //alert(item.user_notification_id)
  let postparmas={
    user_notification_id:item.user_notification_id
  }
  this.restApi.is_view_notofication(postparmas).subscribe((data:any)=>{
    this.toastService.hideLoader();
    this.ionViewWillEnter();
  },(error:any)=>{
    this.toastService.hideLoader();
  })
}
}
